import { gql } from '@apollo/client'

export const COMPLETE_SIGNUP_NUDGE_VIEWER_QUERY = gql`
  query CompleteSignupNudgeViewer {
    root {
      viewer: me {
        pid
        fullname
        cpf
        isCpfValid
        birthDate
        hasPaidPlan
        isB2BSelfService
        mainPhone {
          phone
        }
      }
    }
  }
`
